<template>
    <div class="tron-energy-page">
      <!-- Header Section -->
      <div class="header">
        <div class="header-content">
          <a href="#" style="display:contents">
            <img src="../../public/logo.png" class="logo" />
            <span class="title">波场能量</span>
          </a>
        </div>
    </div>

    
    
    <div class="content">
        <div class="buy-section">
          <div class="title-section">
            <h2>波场能量/tron能量/trx能量购买</h2>
            <p class="subtitle">为您解决"trx交易手续费不足"的问题</p>
          </div>
          


          <div class="form-container">
            <a-card class="energy-card">
              <div class="card-header">
                <h3 style="font-weight:700;padding-top:0.5rem;padding-bottom:0.5rem;padding-left:1rem;padding-right:1rem;
            margin-block-start:0px;    margin-block-end:0px">快捷购买波场能量</h3>
                <a-popover placement="bottomRight">
                  <template #content>
                    <p>对方有U，转账燃烧13TRX，租用65000能量后无需再燃烧</p>
                    <p>对方无U，转账燃烧27TRX，租用{{ usdtEnergyNeedNew }}能量后无需再燃烧</p>
                  </template>
                  <a-button type="text" class="help-btn">
                    <question-circle-outlined />
                    如何估算
                  </a-button>
                </a-popover>
              </div>
  
              <div style="padding-top:0.5rem;padding-bottom:0.5rem;padding-left:0.5rem;padding-right:0.5rem">
                <a-form :model="formState" layout="vertical">
                <!-- Energy Amount Input -->
                <a-form-item
                    style="border-radius:0.5rem"
                  :validate-status="amountError ? 'error' : ''"
                  :help="amountError"
                >
                <a-input-group class="custom-input-group">
                        <a-input
                        v-model:value="formState.amount"
                        placeholder="最少131000"
                        @change="updatePrice"
                        class="custom-theme"
                        />
                        <a-input-group-addon>
                        <a-tag
                            class="energy-tag"
                            @click="setDefaultEnergy('new')"
                        >
                            {{ usdtEnergyNeedNew }}
                        </a-tag>
                        </a-input-group-addon>
                    </a-input-group>
                
                </a-form-item>
  
                <div v-if="true" class="energy-info">
                  <p v-if="formState.amount">本站能量有效期30天</p>
                  <p class="available-energy">
                    平台可用能量 {{ platformAvailEnergy }}
                  </p>
                </div>
  
                <!-- Transaction Count Radio Group -->
              
                <a-form-item  style="text-align: left !important;float:left;padding-bottom:0.75rem;">
                    <a-radio-group
                    v-model:value="formState.period"
                    button-style="solid"
                    @change="updatePrice"
                   
                  >
                    <a-radio-button style="background: #000;color: #fff;" value="1">1笔</a-radio-button>
                    <a-radio-button style="background: #000;color: #fff;" value="10">10笔</a-radio-button>
                    <a-radio-button style="background: #000;color: #fff;" value="50">50笔</a-radio-button>
                    <a-radio-button style="background: #000;color: #fff;" value="100">100笔</a-radio-button>
                  </a-radio-group>
                    
                 
                </a-form-item>
               
               
  
                <!-- Receiver Address Input -->
                <a-form-item  class="custom-theme">
                  
                  <a-input
                    style="background: #000;border: 1px solid #434343;min-height:42px;color: #fff;"
                    v-model:value="formState.receive_address"
                    placeholder="接受能量的账号，不填默认为付款方"
                  >
                  
                  </a-input>
                </a-form-item>
  
                <!-- Price and Buy Button -->
                <div class="price-section">
                  <p>
                    费用预估：<span class="price">{{ totalPrice }}</span> USDT
                  </p>
                  <a-button
                    type="primary"
                    block
                    :loading="loading"
                    :disabled="initial"
                    @click="payWithWallet"
                  >
                    立即购买
                  </a-button>
                </div>
              </a-form>
              </div>
              
            </a-card>
          </div>
        </div>
    </div>

  
      <!-- Confirm Modal -->
      <a-modal
        v-model:visible="confirmVisible"
        :title="confirmTitle"
        :ok-text="confirmOptions?.btn_ok || '确定'"
        :cancel-text="confirmOptions?.btn_cancel || '取消'"
        @ok="handleConfirmOk"
        @cancel="handleConfirmCancel"
      >
        <p>{{ confirmContent }}</p>
      </a-modal>
  
      <!-- Notification -->
      <a-notification
        v-if="notificationVisible"
        :type="notificationType"
        :message="notificationMessage"
        @close="closeNotification"
      />
    </div>
  </template>
  
  <script>
  import { QuestionCircleOutlined } from '@ant-design/icons-vue';
  import { addOrder } from '../util/api'; 
  
  export default {
    name: 'EnergyUse',
    components: {
      QuestionCircleOutlined,
    },
    data() {
      return {
        formState: {
          amount: '',
          period: '1',
          receive_address: '',
        },
        usdtEnergyNeedOld: 65000,
        usdtEnergyNeedNew: 128000,
        platformAvailEnergy: '1061,5901',
        amountError: '',
        totalPrice: 0,
        loading: false,
        initial: false,
        referral_code:"",
        
        // Confirm modal
        confirmVisible: false,
        confirmTitle: '',
        confirmContent: '',
        confirmOptions: null,
        confirmPromise: null,
        
        // Notification
        notificationVisible: false,
        notificationType: 'info',
        notificationMessage: '',
      };
    },

    methods: {
      updatePrice() {
        this.amountError = this.formState.amount ? '' : '请输入能量值';
  
  // Calculate total price and round to 2 decimal places
        if (this.formState.period == "1") {
          this.totalPrice = 0.1; // 四舍五入保留2位小数
        } else  if (this.formState.period == "10"){
          this.totalPrice = 1;
        } else  if (this.formState.period == "50"){
          this.totalPrice = 5;
         } else  if (this.formState.period == "100"){
          this.totalPrice = 10;
         }
      },
      
      setDefaultEnergy(type) {
        this.formState.amount = type === 'new' ? this.usdtEnergyNeedNew : this.usdtEnergyNeedOld;
        this.updatePrice();
      },
      
      async payWithWallet() {
        try {
          this.loading = true;
          // Implement payment logic
          const confirmed = await this.showConfirm(
            '确认购买',
            `您即将购买${this.formState.period} 笔 ${this.formState.amount} 能量，费用为 ${this.totalPrice} USDT`,
            'confirm'
          );
          
          if (confirmed) {
            // Process payment
            let str = this.getCurrentDateTime() + Math.floor(Math.random() * 100000).toString().padStart(6, '0');
            let data = {
                price:this.totalPrice,
                inputNumber:1,
                inputGT:this.formState.receive_address,
                orderNo: str,
                title:"购买"+this.formState.amount+"能量",
                referral_code:this.referral_code
            }

            await addOrder(data)

            this.$router.push({ name: 'Payment', params: { data: JSON.stringify(data) } });


            this.showNotification('success', '购买成功！');
          }
        } catch (error) {
          this.showNotification('error', error.message);
        } finally {
          this.loading = false;
        }
      },
      getCurrentDateTime ()   {
            const date = new Date();
            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            const hours = ("0" + date.getHours()).slice(-2);
            const minutes = ("0" + date.getMinutes()).slice(-2);
            const seconds = ("0" + date.getSeconds()).slice(-2);
            return `${year}${month}${day}${hours}${minutes}${seconds}`;
      },
      
      // Confirm modal methods
      showConfirm(title, content, mode = 'confirm', options = null) {
        this.confirmTitle = title;
        this.confirmContent = content;
        this.confirmOptions = options;
        this.confirmVisible = true;
        console.log(mode)
        
        return new Promise((resolve, reject) => {
          this.confirmPromise = { resolve, reject };
        });
      },
      
      handleConfirmOk() {
        if (this.confirmPromise) {
          this.confirmPromise.resolve(true);
        }
        this.confirmVisible = false;
      },
      
      handleConfirmCancel() {
        if (this.confirmPromise) {
          this.confirmPromise.resolve(false);
        }
        this.confirmVisible = false;
      },
      
      // Notification methods
      showNotification(type, message) {
        this.notificationType = type;
        this.notificationMessage = message;
        this.notificationVisible = true;
        
        // Auto hide after 5 seconds
        setTimeout(() => {
          this.notificationVisible = false;
        }, 5000);
      },
      
      closeNotification() {
        this.notificationVisible = false;
      },
    },
    mounted() {
      this.updatePrice();
      const params = new URLSearchParams(window.location.search);
      this.referral_code = params.get("code") || '';
    },
  };
  </script>
  
  <style scoped>
  .tron-energy-page {
    background-color: #111827;
    color: white;
    min-height: 100vh;
  }
  
  .header {
    background-color: #111827;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.06);
    padding: 0 16px;
    text-align: center;
    margin-bottom:5rem;
  }
  
  .header-content {
    display: flex;
    align-items: center;
    height: 45px;
   
  }
  
  .logo {
    height: 28px;
    margin-right: 8px;
  }
  
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #FFF;
    display: inline-block;
  }
  
  .content {
    padding: 1rem;
    max-width: 1200px;
    margin: 0 auto;
    padding-top:2rem;
    padding-bottom:2rem;


  }
  .available-energy{
    float: right;
  }
  
  .buy-section {
    text-align: center;
    margin-bottom: 32px;
  }
  
  .title-section h2 {
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 8px;
    line-height:2rem;
  }
  
  .subtitle {
    color: #f59e0b;
    margin-block-start:0px

  }
  
  .form-container {
    justify-content:center;
    display:flex;
    max-width: 500px;
    margin: 0 auto;
    margin-top:2rem;
  }
  
  .energy-card {
    background-color: #1e293b;
    border: none;
    border-radius: 12px;
  }
  
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  }
  
  .input-label {
    color: #94a3b8;
  }
  

  
  .energy-info {
    display: flex;
    justify-content: space-between;
    color: #94a3b8;
    font-size: 12px;
  }
  
  .price-section {
    text-align: right;
    margin: 24px 0;
  }
  
  .price {
    color: #f59e0b;
    font-weight: bold;
  }
  
  .help-btn {
    color: #818cf8;
  }

  .custom-input-group {
  min-height: 42px;
}

.custom-input-group :deep(.ant-input) {
  min-height: 42px;
  background: #000;
  width:80%;
  color: #fff;
  border: 1px solid #434343;
  text-align: left;
}

.custom-input-group :deep(.ant-input-group-addon) {
  background: transparent;
  border: none;
  padding: 0;
}

.energy-tag {
  color: #000;
  background: #fff;
  cursor: pointer;
  margin-left: 0px;
  margin-right: 0px;
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
  border-radius: 4px;
  float: left;
}
  </style>